export const EDIT_ACCOUNT = "/fund/edit_account/";
export const CREATE_ACCOUNT = "/fund/create_account/";
export const OVERRIDE_LOW_BALANCE_FLAG = `/fund/:memberId/overide_low_balance/`;
export const GET_LIVE_FUND_VALUE = "/reporting/overall_fund_position";
export const DEACTIVATE_ACCOUNT = "/fund/:id/deactivate/";
export const RESTORE_ACCOUNT = "/fund/:id/restore/";
export const ARCHIVE_ACCOUNT = "/fund/:id/archive/";
export const DELETE_ACCOUNT = "/fund/:id/delete/";
